import React, { useState, useEffect } from 'react'
import {useLocation, useHistory} from 'react-router-dom';
import './iconNav.css'
const icons = [
    {
        img: "/wp-content/themes/tradewater/dist/widget/images/home.jpg",
        alt: "carbon"
    },
    {
        img: "/wp-content/themes/tradewater/dist/widget/images/flights.jpg",
        alt: "flights"
    },
    {
        img: "/wp-content/themes/tradewater/dist/widget/images/driving.jpg",
        alt: "driving"
    },
    {
        img: "/wp-content/themes/tradewater/dist/widget/images/lodging.jpg",
        alt: "lodging"
    }
]
const locationMap = {
    '/': 0,
    '/flights': 1,
    '/driving':2,
    '/lodging':3,
    '/review': 0
}
const locationMapInverse = {
    0: '/',
    1: '/flights',
    2: '/driving',
    3: '/lodging',
    4: '/review'
}
const locationMapInverseClass = {
    '/': "home",
    '/flights': "dynamic",
    '/driving':"dynamic",
    '/lodging':"dynamic",
    '/review': "dynamic"
}

function IconNav() {
    const location = useLocation();
    const history = useHistory();
    const [selected, setSelected] = useState(locationMap[location.pathname]);
    useEffect(()=>{
        setSelected(locationMap[location.pathname])
        
    }, [location])    
    return (
        <div className={`icon-nav ${locationMapInverseClass[location.pathname]}`}>
            {icons.map((i, index)=> 
                <div 
                    className={`icon ${i.alt} `
                    + (selected===index && index != 0?"active":"") 
                    + (selected<index ?"right":"") } >
                    <img onClick={()=> history.push(locationMapInverse[index])} 
                        key={index} 
                        src={i.img} 
                        alt={i.alt}/>
                </div>
            )}            

            <div className={"icon empty " + (selected === 0 ? "active": "")}>

            </div>
        </div>
    )
}

export default IconNav